const DEEPBOX_WEB_PAGE_OVERVIEW = {
  DE: 'https://www.deepbox.swiss/de/ueberblick/',
  FR: 'https://www.deepbox.swiss/fr/apercu/',
  IT: 'https://www.deepbox.swiss/it/panoramica/',
  EN: 'https://www.deepbox.swiss/en/overview/',
}

const DEEPBOX_WEB_PAGE_DOWNLOAD = {
  DE: 'https://www.deepbox.swiss/de/download/',
  FR: 'https://www.deepbox.swiss/fr/download/',
  IT: 'https://www.deepbox.swiss/it/download/',
  EN: 'https://www.deepbox.swiss/download/',
}

export const links = {
  DEEPBOX_WEB_PAGE_OVERVIEW,
  DEEPBOX_WEB_PAGE_DOWNLOAD,
}
